import { Fragment } from 'react';

import EditIcon from '@usas/ui-web/components/icons/EditIcon';
import DeleteIcon from '@usas/ui-web/components/icons/DeleteIcon';
import PlusIcon from '@usas/ui-web/components/icons/PlusIcon';
import ActionIntraPageButton from '@usas/ui-web/components/buttons/ActionIntraPageButton';

import { formatDateTime, formatDateTimeTwelveHourClock } from '@usas/ui-web/utils/DateFunctions';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const LargeDetailTableRow = ({ omeMeetEntry, host }) => {
  return (
    <tr>
      <td>{omeMeetEntry.omeMeetName || ''}</td>
      <td>{omeMeetEntry?.meetEntryStartDate ? formatDateTimeTwelveHourClock(omeMeetEntry?.meetEntryStartDate) : ''} {omeMeetEntry?.meetEntryStartDate ? "-" : ''} {omeMeetEntry?.meetEntryEndDate ? formatDateTimeTwelveHourClock(omeMeetEntry?.meetEntryEndDate) : ''}</td>
      <td>{host?.timeZone || ''}</td>
      <td>{omeMeetEntry.status || ''}</td>
    </tr>
  )
};

const LargeDetailTable = ({ omeMeetEntryArray, host }) => {
  return (
    <table className={global.DetailTable}>
      <thead>
        <tr>
          <th>OME Meet Name</th>
          <th style={{ minWidth: '305px' }}>Entry Start - End Dates</th>
          <th style={{ minWidth: '180px' }}>Time Zone</th>
          <th style={{ minWidth: '125px' }}>Status</th>
        </tr>
      </thead>
      <tbody>
        {Array.isArray(omeMeetEntryArray) && omeMeetEntryArray.length > 0 &&
          omeMeetEntryArray.map((omeMeetEntry, i) =>
            <LargeDetailTableRow
              key={i}
              omeMeetEntry={omeMeetEntry}
              host={host}
            />)}
      </tbody>
    </table>
  );
};

const GridRow = ({ host, onView, onEdit, onDeleteOmeMeetClicked }) => {
  return (
    <Fragment>
      <tr>
        <td>{host?.orgUnitName || ''}</td>
        <td>{host?.omeMeetId > 0 ? (host?.status || '') : 'Not Created'}</td>
        <td>
          {host?.omeMeetId > 0 &&
            <span>
              {host?.isReadOnly === true &&
                <ActionIntraPageButton onClick={(e) => onView(e)}>View</ActionIntraPageButton>}
              {host?.hostChangesCurrentlyAllowed === true &&
                <button className={global.IconButtonMargin} type="button" onClick={(e) => onEdit(e)}><EditIcon /></button>}
              {host?.hostDeletesCurrentlyAllowed === true &&
                <button className={global.IconButtonMargin} type="button" onClick={(e) => onDeleteOmeMeetClicked(e, host)}><DeleteIcon /></button>}
            </span>}
        </td>
      </tr>
      {Array.isArray(host?.omeMeetEntry) && host?.omeMeetEntry?.length > 0 &&
        <tr className={global.Expanded}>
          <td colSpan="6">
            <LargeDetailTable
              omeMeetEntryArray={host?.omeMeetEntry}
              host={host}
            />
          </td>
        </tr>
      }
    </Fragment>
  );
};

const MeetHostLargeGrid = ({ gridData, isLoading, meetState, onEnterOmeHostClicked, onView, onEdit, onDeleteOmeMeetClicked }) => (
  <Fragment>
    <table className={[global.UsasTable, 'visible-md visible-lg'].join(' ')}>
      <thead>
        <tr>
          <th>Meet Host</th>
          <th>OME Meet Status</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {isLoading === true ?
          <tr><td colSpan="3">Loading...</td></tr>
          : Array.isArray(gridData) && gridData.length > 0 ?
            gridData.map((host, i) =>
              <GridRow
                key={i}
                host={host}
                onView={onView}
                onEdit={onEdit}
                onDeleteOmeMeetClicked={onDeleteOmeMeetClicked}
              />)
            :
            <tr>
              <td>{meetState.objData?.hostOrgUnit?.orgUnitName || ''}</td>
              <td>Not Created</td>
              <td>
                {meetState?.objData.startDate && (new Date(formatDateTime(meetState?.objData?.startDate)) > new Date()) ?
                  <button className={global.IconButtonMargin} type="button" onClick={(e) => onEnterOmeHostClicked(e)}> <PlusIcon toolTipText='Create OME Meet' /> </button> : <Fragment />}
              </td>
            </tr>
        }
      </tbody>
    </table>
  </Fragment>
);

export default MeetHostLargeGrid;